export default __webpack_public_path__ + "static/media/info.b1c11f93.svg";